module.exports = __webpack_public_path__ + "img/task(10).5b779546.png";